import * as React from 'react'
import {
  Dialog, DialogActions, DialogContent, DialogContentText, withStyles, WithStyles
} from '@zn-material-ui'
import Store from 'store'
import DialogTitle from '@components/DialogTitle'
import captchaDialogStyles from './styles/CaptchaDialogStyle'
import { Login } from '@services/api'
import { MD5 } from '@utils/lib'
import { rsaEncodeString } from '@utils'
import AdornedButton from '@components/AdornedButton'
import CaptchaInput from './CaptchaInput'
import { transform } from '@utils/intl_lang'
interface IProps extends WithStyles<typeof captchaDialogStyles> {
  cellphoneNumber: string
  onClose: () => void
  onSuccess: () => void
  requestType: string
  area: string
}

const CaptchaDialog: React.SFC<IProps> = props => {
  const [captcha, setCaptcha] = React.useState('')
  const [captchaUrl, setCaptchaUrl] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [captchaError, setCaptchaError] = React.useState(false)
  const {
    cellphoneNumber,
    onClose,
    classes,
    onSuccess,
    requestType,
    area,
  } = props
  React.useEffect(() => {
    handleUpdateCaptchaImg()
  }, [])

  const handleCaptchaChange = (event: any) => {
    setCaptcha(event.target.value)
  }

  const handleUpdateCaptchaImg = () => {
    const randomCode = Math.random().toString()
    setCaptchaUrl(
      Login.getSafeImgCaptcha(`${area}${cellphoneNumber}`, randomCode)
    )
  }

  const handleOk = async () => {
    const areaCode = Store.get('areaCode') || area
    const code = areaCode ? `00${areaCode}` : ''
    const mobilePhone = `${code}${cellphoneNumber}`
    const pwd = rsaEncodeString(mobilePhone + MD5(cellphoneNumber))
    setLoading(true)
    const result = await Login.sendVerCodeCaptcha({
      mobilePhone,
      requestType,
      encryptCode: pwd,
      validate: captcha.toUpperCase(),
      deviceId: MD5(cellphoneNumber),
      queryTime: Date.now().toString(),
    })
    setLoading(false)
    if (result.code === 0 && result.returnCode === '0') {
      setCaptchaError(false)
      onSuccess()
      global.$message(result.message, {
        variant: 'success',
      })
    } else {
      if (result.returnCode === '-13') {
        setCaptchaError(true)
      } else {
        global.$message(result.message, {
          variant: 'error',
        })
      }
    }
  }

  return (
    <Dialog
      open={true}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle onClose={onClose} />
      <DialogContent className={classes.dialogContent}>
        <DialogContentText className={classes.sendText}>
          {/* 短信即将发送至： */}
          {transform('Login_send_message')}
        </DialogContentText>
        <DialogContentText className={classes.cellphoneNumber}>
          {cellphoneNumber}
        </DialogContentText>
        <CaptchaInput
          captchaError={captchaError}
          captcha={captcha}
          handleCaptchaChange={handleCaptchaChange}
          handleUpdateCaptchaImg={handleUpdateCaptchaImg}
          captchaUrl={captchaUrl}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <AdornedButton
          variant="contained"
          onClick={handleOk}
          color="primary"
          className={classes.okBtn}
          loading={loading}
        >
          {/* 确 定 */}
          {transform('confirm_empty')}
        </AdornedButton>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(captchaDialogStyles)(CaptchaDialog)
